import styled from "@emotion/styled";
import { Box, IconButton, Typography } from "@avenue-8/sidekick-ui";
import { PresentationDisplayMode } from "../PresentationSectionProps";

export const MapLegend = styled.div<{ $displayMode?: PresentationDisplayMode }>`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 680px;
  margin: auto;
  padding: 1rem 1.5rem 0 1rem;

  ${(p) =>
    p.$displayMode === "print" &&
    `
    max-width: 90%;
    transform: scale(1.3);
  `}
`;

export const BulletIcon = styled.span<{ markerColor?: string }>`
  ${(p) =>
    p.markerColor
      ? `
    background-color: ${p.markerColor};
  `
      : ""}
  width: 0.7em;
  height: 0.7em;
  border-radius: 50%;
  display: inline-block;
  margin-right: 0.25rem;
`;

export const MapLegendItem = styled(Typography)`
  display: flex;
  gap: 0.125rem;
  align-items: center;
  font-size: ${(p) => p.theme.text.fontSizes.xs};
  text-align: center;
  white-space: nowrap;
  padding: 0.5rem;
`;

export const MapContainer = styled(Box)`
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  overflow: hidden;
  border-radius: 0.5rem;
  z-index: 1;
`;

export const FullScreenIconButton = styled(IconButton)`
  background-color: ${(p) => p.theme.button.outlined.colors.background};
  color: ${(p) => p.theme.button.outlined.colors.text};
  position: absolute;
  right: 0.5rem;
  top: 0.5rem;
  z-index: 1;
  padding: 0.5rem;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  &:hover {
    color: ${(p) => p.theme.button.outlined.hover.text};
  }
`;

export const MapWrapper = styled(Box)`
  position: relative;
  border-radius: 0.5rem;
  width: 100%;
  margin: 0 auto;
  max-width: 1200px;
  height: 55dvh;
  min-height: 300px;
  overflow: hidden;
`;

export const MapWrapperPrint = styled(Box)`
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
  @media print {
    width: calc(297mm - 2 * 10mm);
  }
`;
